<label *ngIf="leftLabel">{{ label }}</label>
<div #dropdownContainer class="input-field" [class.invalid]="hasError"
     (click)="preventPropagation($event)">
    <label *ngIf="topLabel" for="float-input" class="active">{{ label }}</label>
    <select [required]="true"
            [ngModel]="value"
            [disabled]="isDisabled"
            (ngModelChange)="onItemSelect($event)">
        <!-- Empty option for the placeholder -->
        <option [value]="" selected disabled>{{ emptyText }}</option>
        <!-- List of items -->
        <option *ngFor="let item of items; trackBy: trackByFn"
                [value]="item[valueField]">
            {{ item[displayField] }}
        </option>
    </select>
    <label *ngIf="floatLabel" for="float-input" class="active">{{ label }}</label>
    <app-form-error-list *ngIf="showErrors"
                         [errorMap]="formControl.errors"></app-form-error-list>
</div>
